import { render } from "./ConfirmAssignModal.vue?vue&type=template&id=528676dc&scoped=true&ts=true"
import script from "./ConfirmAssignModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmAssignModal.vue?vue&type=script&lang=ts"

import "./ConfirmAssignModal.vue?vue&type=style&index=0&id=528676dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528676dc"]])

export default __exports__